import {
  Button,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BlogPost } from "../../const/types";
import { Trash } from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";
import { useNavigate } from "react-router-dom";

type Props = {
  data: BlogPost;
};

export default function DeleteBlogPostModal({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();
  const navigate = useNavigate();

  const onDelete = () => {
    setLoading(true);
    const url = `api/blog/post/${data.id}/destroy`;
    cr.delete(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
          navigate("/blog/post");
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <IconButton
        onClick={onOpen}
        colorScheme="red"
        variant={"ghost"}
        aria-label="deleteKategori"
        className="clicky"
        size={"sm"}
        icon={<Icon as={Trash} fontSize={iconSize} />}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Delete Post</ModalHeader>

          <ModalBody>
            <Text mb={4}>
              Apakah Anda yakin akan menghapus blog post ini <b>{data.title}</b>
            </Text>
            <Text opacity={0.5} fontSize={"small"}>
              Data blog post tidak dihapus permanen, blog post yang telah
              dihapus dapat dikembalikan lagi di menu <b>Restore</b>
            </Text>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button
              className="btn clicky"
              onClick={onClose}
            >
              Batal
            </Button>

            <Button
              colorScheme="red"
              className="clicky"
              onClick={onDelete}
              isLoading={loading}
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
